<template>
  <div class="todo-select" :tabindex="tabindex" @blur="open = false">
    <div class="category" :class="{open: open}" @click="open = !open">{{ category }}</div>
    <div class="items" :class="{selectHide: !open}">
      <div
        class="item"
        v-for="(option, i) of options"
        :key="i"
        @click="selection(option)">{{ option }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      category: this.options.length > 0 ? this.options[0] : null,
      open: false,
    };
  },
  mounted() {
    this.$emit('input', this.category);
  },
  methods: {
    selection(option) {
      this.category = option;
      this.$emit('input', option);
      this.open = false;
    },
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style scoped>

.todo-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 60px;
  font-family: futura-pt, serif;
  font-weight: 400;
  font-style: normal;
  text-transform: uppercase;
  font-size: 16px;
}

.category {
  background-color: transparent;
  border-radius: 1px;
  border-top: 0.5px solid white;
  color: white;
  padding-left: 8px;
  cursor: pointer;
  user-select: none;
  padding-top: 19px;
  padding-bottom: 19px;
  padding-left: 40px;
}

.category.open {
  border: 0.5px solid white;
  border-radius: 1px;
  color: black;
  background-color: white;
}

.category:after {
  position: absolute;
  top: 22px;
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-color: #fff transparent transparent transparent;
  color: white !important;
}

.items {
  border-radius: 0.5px;
  overflow: hidden;
  border-right: 0.5px solid white;
  border-left: 0.5px solid white;
  border-bottom: 0.5px solid white;
  position: absolute;
  background-color: white;
  left: 0;
  right: 0;

}

.item {
  color: grey;
  cursor: pointer;
  user-select: none;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 30px;
}


.item:hover {
  background-color: white;
  color: black;
}

.selectHide {
  display: none;
}
</style>
